/*
 * @Author: ymk
 * @Date: 2020-07-23 14:08:21
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-23 14:13:39
 * @FilePath: \car-demo\src\router\demo.js
 */

const demoRoutes = [
	{
		path: '/init',
		name: 'init',
		component: () => import('../views/init.vue'),
	},
	{
		path: '/demo',
		name: 'demo',
		component: () => import(/* webpackChunkName: "about" */ '../views/Demo.vue'),
	},
	// 地图
	{
		path: '/map',
		name: 'map',
		component: () => import('../views/Map.vue')
	}
]

export default demoRoutes;
